/**
 * @file _view/_form-submit.js
 */
(function ($) {
	'use strict';
	// options
	var validateOption = {
		errorClassName   : 'error',
		parentClassName  : 'form-group',
		sysErrorAlert    : false,
		useParentError   : true,
		specialCharCheck : false,
		showAsPopup      : false,
		errorMsgClassName: 'error-message'
	};

	/**
	 * @namespace SubmitForm
	 * @constructor
	 * @classdesc submit button押した時に入力内容をチェック
	 * @param {Object} $e -対象となる jQuery オブジェクト
	 */
	var FormSubmit = function ($e) {
		this._$e = $e;
		console.info(this._$e);
		this._$e.on('click', this.validate.bind(this));
	};


	/**
	 * @memberOf FormSubmit
	 * @const {}
	 */
	FormSubmit._classname = 'FormSubmit';


	/**
	 * フォームのバリデート
	 *
	 * @memberOf FormSubmit
	 */
	FormSubmit.prototype.validate = function (e) {
		e.preventDefault();
		var form = $('.wpcf7-form');
		form.find('.validate').each(function () {
			$(this).WizValidator(validateOption);
		});
		if (form.find('.validate').hasClass('error')) {
			alert('入力項目が不正です。');
			return;
		} else {
			$('.wpcf7-form').submit();
		}
	};

	module.exports = FormSubmit;
})(jQuery);